// extracted by mini-css-extract-plugin
export default {"container":"MakeBooking_container__7fY9C","timeSlotInputWrapper":"MakeBooking_timeSlotInputWrapper__5iAei"};